module.exports = __webpack_public_path__ + "static/media/mask@2x.5015bd8a.png";